// import React, { useEffect, useState, useRef } from "react";
// import {
//   MapContainer,
//   TileLayer,
//   GeoJSON,
//   LayersControl,
// } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import proj4 from "proj4";
// import L from "leaflet";

// const Infrastructure = () => {
//   const [boundaryData, setBoundaryData] = useState(null);
//   const [schoolData, setSchoolData] = useState(null);
//   const [sectorialLayers, setSectorialLayers] = useState({});

//   const center = [-8.8742, 125.7275];
//   const INITIAL_VIEW_STATE = {
//     zoom: 8,
//   };

//   proj4.defs(
//     "EPSG:32751",
//     "+proj=utm +zone=51 +south +datum=WGS84 +units=m +no_defs"
//   );

//   const reprojectCoordinates = (coordinates) => {
//     return coordinates.map((point) =>
//       Array.isArray(point[0])
//         ? reprojectCoordinates(point)
//         : proj4("EPSG:32751", "EPSG:4326", point)
//     );
//   };

//   const reprojectGeoJSON = (geojson) => {
//     if (!geojson || !geojson.type) return geojson;
//     const reprojected = { ...geojson };

//     if (geojson.type === "FeatureCollection") {
//       reprojected.features = geojson.features.map((feature) => ({
//         ...feature,
//         geometry: {
//           ...feature.geometry,
//           coordinates: reprojectCoordinates(feature.geometry.coordinates),
//         },
//       }));
//     } else if (geojson.type === "Feature") {
//       reprojected.geometry.coordinates = reprojectCoordinates(
//         geojson.geometry.coordinates
//       );
//     }

//     return reprojected;
//   };

//   const sectorialColors = {
//     School: "blue",
//     Hospital: "red",
//     Courthouse: "darkgray",
//     Policestation: "navy",
//     College: "purple",
//     POFW: "lightgreen",
//     Marketplace: "orange",
//     Pharmacy: "pink",
//     Government: "gold",
//     Preschool: "skyblue",
//     University: "darkpurple",
//     Clinic: "lightred",
//     CommunityCentre: "teal",
//     PowerSubstation: "brown",
//     FireStation: "red",
//     Childcare: "yellow",
//     Powerplant: "darkbrown",
//     Townhall: "olive",
//     Water_reservoir: "aqua",
//     Port: "darkblue",
//     Water_point: "cyan",
//     PowerTower: "gray",
//   };

//   useEffect(() => {
//     fetch("/DATA/OSMbased_adm0_boundary.json")
//       .then((response) => response.json())
//       .then((data) => setBoundaryData(data))
//       .catch((error) => console.error("Error loading boundary data:", error));
//   }, []);

//   useEffect(() => {
//     fetch("/cityfire/Schools_2012_DNE.json")
//       .then((response) => response.json())
//       .then((data) => setSchoolData(data))
//       .catch((error) => console.error("Error loading school data:", error));
//   }, []);

//   useEffect(() => {
//     fetch("/cityfire/infra_poly.geojson")
//       .then((response) => response.json())
//       .then((data) => {
//         const reprojectedData = reprojectGeoJSON(data);
//         const grouped = {};

//         reprojectedData.features.forEach((feature) => {
//           const type = feature.properties?.SectorialS || "Unknown";
//           if (!grouped[type]) grouped[type] = [];
//           feature.properties.color = sectorialColors[type] || "black";
//           grouped[type].push(feature);
//         });

//         const layerData = {};
//         for (const [type, features] of Object.entries(grouped)) {
//           layerData[type] = {
//             type: "FeatureCollection",
//             features,
//           };
//         }

//         setSectorialLayers(layerData);
//       })
//       .catch((error) =>
//         console.error("Error loading infrastructure data:", error)
//       );
//   }, []);

//   const [legendVisible, setLegendVisible] = useState(false);
//   const legendRef = useRef(null);

//   const toggleLegend = () => {
//     setLegendVisible(!legendVisible);
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (legendRef.current && !legendRef.current.contains(event.target)) {
//         setLegendVisible(false);
//       }
//     };

//     if (legendVisible) {
//       document.addEventListener("mousedown", handleClickOutside);
//     } else {
//       document.removeEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [legendVisible]);

//   return (
//     <div className="mapcontainerall">
//       <MapContainer
//         center={center}
//         zoom={INITIAL_VIEW_STATE.zoom}
//         style={{ height: "100%", width: "100%" }}
//       >
//         <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

//         <LayersControl position="topright">
//           {boundaryData && (
//             <LayersControl.Overlay name="Country" checked>
//               <GeoJSON
//                 data={boundaryData}
//                 style={{ color: "blue", weight: 2, fillOpacity: 0 }}
//               />
//             </LayersControl.Overlay>
//           )}

//           {/* Dynamically render sectorial layers */}
//           {sectorialLayers &&
//             Object.entries(sectorialLayers).map(([type, data]) => (
//               <LayersControl.Overlay key={type} name={type} checked>
//                 <GeoJSON
//                   data={data}
//                   style={() => ({
//                     color: sectorialColors[type] || "black",
//                     radius: 1.5,
//                     weight: 5,
//                     fillOpacity: 0.5,
//                   })}
//                   onEachFeature={(feature, layer) => {
//                     const sectorialS = feature.properties?.SectorialS || "Unknown";
//                     layer.bindPopup(
//                       `<b>Infrastructure</b><br>Category: ${sectorialS}`
//                     );
//                   }}
//                 />
//               </LayersControl.Overlay>
//             ))}

//           {schoolData && (
//             <LayersControl.Overlay name="Schools">
//               <GeoJSON
//                 data={schoolData}
//                 pointToLayer={(feature, latlng) => {
//                   let fillColor = "blue";
//                   if (feature.properties.type_name === "Public") {
//                     fillColor = "green";
//                   } else if (feature.properties.type_name === "Catholic") {
//                     fillColor = "yellow";
//                   } else if (feature.properties.type_name === "Private") {
//                     fillColor = "blue";
//                   }

//                   return L.circleMarker(latlng, {
//                     radius: 1.5,
//                     color: fillColor,
//                     weight: 1,
//                     fillColor: fillColor,
//                     fillOpacity: 0.5,
//                   });
//                 }}
//                 onEachFeature={(feature, layer) => {
//                   if (feature.properties) {
//                     layer.bindPopup(
//                       `<b>School Info</b><br>${Object.entries(
//                         feature.properties
//                       )
//                         .map(([key, value]) => `${key}: ${value}`)
//                         .join("<br>")}`
//                     );
//                   }
//                 }}
//               />
//             </LayersControl.Overlay>
//           )}
//         </LayersControl>

//         <div className="legend-home">
//             <h4>Legend</h4>
//             <div className="legend-items">
//             <div className="legendss-item">
//                   <i style={{ background: "green", opacity: "0.8", border: "1px solid black"   }}></i>
//                   <span>Primary Public</span>
//                 </div>
//                 <div className="legendss-item">
//                   <i style={{ background: "blue", opacity: "0.8", border: "1px solid black"   }}></i>
//                   <span>Secondary Private</span>
//                 </div>
//                 <div className="legendss-item">
//                   <i style={{ background: "yellow", opacity: "0.8", border: "1px solid black"   }}></i>
//                   <span>Primary Catholic</span>
//                 </div>
//               </div>
//             </div>
//       </MapContainer>
//     </div>
//   );
// };

// export default Infrastructure;


import React, { useEffect, useState, useCallback, useMemo } from "react";
import {
  MapContainer,
  TileLayer,
  GeoJSON,
  LayersControl,
  // useMap,
} from "react-leaflet";
import { FaCircleInfo } from "react-icons/fa6";
import "leaflet/dist/leaflet.css";
import proj4 from "proj4";
import L from "leaflet";
import { MapHomeControl, MapLegendControl } from "../../common/MapControls/MapControls";

const Infrastructure = () => {
  const [boundaryData, setBoundaryData] = useState(null);
  const [schoolData, setSchoolData] = useState(null);
  const [sectorialLayers, setSectorialLayers] = useState({});
  const [info, setInfo] = useState(false);
  const [mapBounds, setMapBounds] = useState(null); // State to store the calculated bounds

  proj4.defs(
    "EPSG:32751",
    "+proj=utm +zone=51 +south +datum=WGS84 +units=m +no_defs"
  );

  const reprojectCoordinates = useCallback((coordinates) => {
    return coordinates.map((point) =>
      Array.isArray(point[0])
        ? reprojectCoordinates(point)
        : proj4("EPSG:32751", "EPSG:4326", point)
    );
  }, []);

  const reprojectGeoJSON = useCallback((geojson) => {
    if (!geojson || !geojson.type) return geojson;
    const reprojected = { ...geojson };

    if (geojson.type === "FeatureCollection") {
      reprojected.features = geojson.features.map((feature) => ({
        ...feature,
        geometry: {
          ...feature.geometry,
          coordinates: reprojectCoordinates(feature.geometry.coordinates),
        },
      }));
    } else if (geojson.type === "Feature") {
      reprojected.geometry.coordinates = reprojectCoordinates(
        geojson.geometry.coordinates
      );
    }

    return reprojected;
  }, [reprojectCoordinates]);

  const sectorialColors = useMemo(() => ({
    School: "blue",
    Hospital: "red",
    Courthouse: "darkgray",
    Policestation: "navy",
    College: "purple",
    POFW: "lightgreen",
    Marketplace: "orange",
    Pharmacy: "pink",
    Government: "gold",
    Preschool: "skyblue",
    University: "darkpurple",
    Clinic: "lightcoral",
    CommunityCentre: "teal",
    PowerSubstation: "brown",
    FireStation: "darkred",
    Childcare: "yellow",
    Powerplant: "darkslategray",
    Townhall: "olive",
    Water_reservoir: "aqua",
    Port: "darkblue",
    Water_point: "cyan",
    PowerTower: "gray",
  }), []);

  // --- Start of change for map bounds ---
  useEffect(() => {
    Promise.all([
      fetch("/DATA/OSMbased_adm0_boundary.json").then((res) => res.json()),
      fetch("/cityfire/Schools_2012_DNE.json").then((res) => res.json()),
      fetch("/cityfire/infra_poly.geojson").then((res) => res.json()),
    ])
    .then(([boundary, schools, infrastructure]) => {
      setBoundaryData(boundary);
      setSchoolData(schools);

      // Reproject and group infrastructure data
      const reprojectedData = reprojectGeoJSON(infrastructure);
      const grouped = {};

      reprojectedData.features.forEach((feature) => {
        const type = feature.properties?.SectorialS || "Unknown";
        if (!grouped[type]) grouped[type] = [];
        feature.properties.color = sectorialColors[type] || "black";
        grouped[type].push(feature);
      });

      const layerData = {};
      for (const [type, features] of Object.entries(grouped)) {
        layerData[type] = {
          type: "FeatureCollection",
          features,
        };
      }
      setSectorialLayers(layerData);

      // Calculate and set map bounds based on the boundary data
      if (boundary && boundary.features && boundary.features.length > 0) {
        const geoJsonLayer = L.geoJSON(boundary);
        setMapBounds(geoJsonLayer.getBounds());
      }
    })
    .catch((error) => console.error("Error loading GeoJSON data:", error));
  }, [reprojectGeoJSON, sectorialColors]);
  // --- End of change for map bounds ---

  const InfoButton = ({ onClick }) => {
    // Leaflet's own drag/click handling swallows clicks on overlay controls
    // unless propagation to the map is explicitly disabled on the DOM node.
    const btnRef = useCallback((node) => {
      if (node) {
        L.DomEvent.disableClickPropagation(node);
        L.DomEvent.disableScrollPropagation(node);
      }
    }, []);
    return (
      <div
        ref={btnRef}
        style={{
          position: "absolute",
          bottom: "20px",
          left: "12px",
          padding: "8px",
          borderRadius: "8px",
          fontSize: "15px",
          cursor: "pointer",
        background: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(10px) brightness(1.1)",
        WebkitBackdropFilter: "blur(10px) brightness(1.1)",
        border: "1px solid rgba(0, 0, 0, 0.08)",
        color: "#333333",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        transition: "all 0.2s ease",
          zIndex: 1000,
        }}
        onClick={onClick}
      >
        <FaCircleInfo />
      </div>
    );
  };

  const Legend = ({ sectorialColors }) => {
    const legendItems = useMemo(() => {
      const items = [];
      items.push({ label: "Schools - Public", color: "green" });
      items.push({ label: "Schools - Catholic", color: "yellow" });
      items.push({ label: "Schools - Private", color: "blue" });

      const filteredSectorialColors = Object.entries(sectorialColors).filter(([key]) => key !== 'School');
      filteredSectorialColors.forEach(([name, color]) => {
        items.push({ label: name.replace(/([A-Z])/g, ' $1').trim(), color: color });
      });

      items.sort((a, b) => a.label.localeCompare(b.label));
      return items;
    }, [sectorialColors]);

    if (legendItems.length === 0) {
      return null;
    }

    return <MapLegendControl sections={[{ shape: "square", items: legendItems }]} />;
  };

  // Leaflet's own drag/click handling swallows clicks on overlay controls
  // unless propagation to the map is explicitly disabled on the DOM node.
  const infoPanelRef = useCallback((node) => {
    if (node) {
      L.DomEvent.disableClickPropagation(node);
      L.DomEvent.disableScrollPropagation(node);
    }
  }, []);

  return (
    <div className="mapcontainerall">
      {/* Conditionally render MapContainer only when mapBounds is available */}
      {mapBounds && (
        <MapContainer
          bounds={mapBounds} // Use the calculated bounds here
          style={{ height: "100%", width: "100%" }}
        >
          <MapHomeControl />
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

          <LayersControl position="topright">
            {boundaryData && (
              <LayersControl.Overlay name="Country" checked>
                <GeoJSON
                  data={boundaryData}
                  style={{ color: "blue", weight: 2, fillOpacity: 0 }}
                />
              </LayersControl.Overlay>
            )}

            {sectorialLayers &&
              Object.entries(sectorialLayers).map(([type, data]) => (
                <LayersControl.Overlay key={type} name={type} checked>
                  <GeoJSON
                    data={data}
                    style={() => ({
                      color: sectorialColors[type] || "black",
                      radius: 1.5,
                      weight: 5,
                      fillOpacity: 0.5,
                    })}
                    onEachFeature={(feature, layer) => {
                      const sectorialS = feature.properties?.SectorialS || "Unknown";
                      layer.bindPopup(
                        `<b>Infrastructure</b><br>Category: ${sectorialS}`
                      );
                    }}
                  />
                </LayersControl.Overlay>
              ))}

            {schoolData && (
              <LayersControl.Overlay name="Schools">
                <GeoJSON
                  data={schoolData}
                  pointToLayer={(feature, latlng) => {
                    let fillColor = "blue";
                    if (feature.properties.type_name === "Public") {
                      fillColor = "green";
                    } else if (feature.properties.type_name === "Catholic") {
                      fillColor = "yellow";
                    } else if (feature.properties.type_name === "Private") {
                      fillColor = "blue";
                    }

                    return L.circleMarker(latlng, {
                      radius: 1.5,
                      color: fillColor,
                      weight: 1,
                      fillColor: fillColor,
                      fillOpacity: 0.5,
                    });
                  }}
                  onEachFeature={(feature, layer) => {
                    if (feature.properties) {
                      layer.bindPopup(
                        `<b>School Info</b><br>${Object.entries(
                          feature.properties
                        )
                          .map(([key, value]) => `${key}: ${value}`)
                          .join("<br>")}`
                      );
                    }
                  }}
                />
              </LayersControl.Overlay>
            )}
          </LayersControl>

          {info && (
            <div
              ref={infoPanelRef}
              style={{
                position: "absolute",
                bottom: "70px",
                left: "12px",
                fontSize: "12px",
                zIndex: 1000,
                padding: "10px 14px",
                borderRadius: "10px",
                background: "rgba(255, 255, 255, 0.9)",
                backdropFilter: "blur(10px) brightness(1.1)",
                WebkitBackdropFilter: "blur(10px) brightness(1.1)",
                border: "1px solid rgba(0, 0, 0, 0.08)",
                boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15), inset 0 1px 2px rgba(255, 255, 255, 0.5)",
                color: "#333333",
                fontWeight: "500",
                maxWidth: "320px",
                lineHeight: "1.4",
              }}
            >
              This page displays various infrastructure data points across the region.
              Including Schools (Public, Catholic, Private) and various sectorial facilities.
            </div>
          )}
          <InfoButton onClick={() => setInfo(!info)} />

          <Legend sectorialColors={sectorialColors} />
        </MapContainer>
      )}
    </div>
  );
};

export default Infrastructure;